export const PAX_FLIGHT_STATUSES = [
  { name: 'Manually Added', id: -1 },
  { name: 'Loading', id: 0 },
  { name: 'Not Boarded', id: 1 },
  { name: 'Boarded', id: 2 },
  { name: 'Denied', id: 3 },
  { name: 'No Show', id: 4 },
];
